// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2lLtj","label":"SetPasswdForm_label__BElbE"};